// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"790e602d","389":"f5c1682b","455":"ef30dac3","488":"048c20cd","575":"c54c961b","977":"686ecda1"}[chunkId] + ".chunk.js";
};